import partnersRoutes from './crm/partners/partners/index.routes'
import interactionsRoutes from './crm/interactions/interactions/index.routes'
import systemMasterDataRoutes from './system/master-data/index.routes'
import newsletterMasterDataRoutes from './newsletter/master-data/index.routes'
import systemRoutes from './system/system/index.routes'
import newsletterRoutes from './newsletter/newsletter/index.routes'
import authRoutes from './system/auth/index.routes'
import deploymentRoutes from "./deployment/deployment.routes";
import organizationMasterDataRoutes from './organization/master-data/index.routes'
import organizationRoutes from './organization/organization/index.routes'
import newsletterLogs from './newsletter/log/index.routes';
import partnersMasterDataRoutes from './crm/partners/master-data/index.routes'
import interactionsMasterDataRoutes from './crm/interactions/master-data/index.routes'
import projectsRoutes from './crm/projects/projects/index.routes'
import projectsMasterDataRoutes from './crm/projects/master-data/index.routes'
import projectsSystemRoutes from './crm/projects/system/index.routes'
import tasksRoutes from './crm/tasks/tasks/index.routes'
import tasksMasterDataRoutes from './crm/tasks/master-data/index.routes'
import invoicesRoutes from './crm/invoices/invoices/index.routes'
import invoicesMasterDataRoutes from './crm/invoices/master-data/index.routes'
import remindersRoutes from './crm/reminders/reminders/index.routes'

export default [
    {
        // =========================
        // HOME AFTER LOGIN
        // =========================
        path: '/',
        name: 'home',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.home').ucFirst();
            },
        },
        component: () => import('@/views/layouts/main.vue'),
        children: [
            {
                path: '403',
                name: 'pages-403',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('base.forbidden').ucFirst();
                    },
                },
                component: () => import('@/views/pages/error/403.vue')
            },
            {
                path: 'subordinates',
                name: 'subordinates',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.subordinates').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/users/subordinates-dashboard.vue')
            },
            {
                path: 'reports',
                name: 'reports',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.reports').ucFirst();
                    },
                },
                component: () => import('@/views/pages/reports/dashboard.vue')
            },
            {
                path: 'partners',
                name: 'partners',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.partners').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: partnersRoutes
            },
            {
                path: 'interactions',
                name: 'personal-interactions',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: ['modules.crm'],
                    translate: (t) => {
                        return t('menu_points.interactions').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'my-interactions' },
                children: interactionsRoutes
            },
            {
                path: 'projects',
                name: 'projects',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.projects').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'projects-my-projects' },
                children: projectsRoutes
            },
            {
                path: 'tasks',
                name: 'tasks',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.tasks').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'tasks-my-tasks' },
                children: tasksRoutes
            },
            {
                path: 'invoices',
                name: 'invoices',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.invoices').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'invoices-my-invoices' },
                children: invoicesRoutes
            },
            {
                path: 'reminders',
                name: 'reminders',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.reminders').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'my-reminders' },
                children: remindersRoutes
            },
            {
                path: 'newsletters',
                name: 'newsletters',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.newsletters').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-list'},
                children: newsletterRoutes
            },
            {
                path: 'organizations',
                name: 'organizations',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['modules.organization'],
                    translate: (t) => {
                        return t('menu_points.organization_management').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'organizations-organizations-list'},
                children: organizationRoutes
            },
            ...deploymentRoutes,
            {
                path: 'master-data',
                name: 'master-data',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.master_data').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: [
                    ...systemMasterDataRoutes,
                    ...newsletterMasterDataRoutes,
                    ...organizationMasterDataRoutes,
                    ...partnersMasterDataRoutes,
                    ...interactionsMasterDataRoutes,
                    ...projectsMasterDataRoutes,
                    ...tasksMasterDataRoutes,
                    ...invoicesMasterDataRoutes,
                ]
            },
            {
                path: 'system',
                name: 'system',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.system').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: [
                    ...systemRoutes,
                    ...projectsSystemRoutes,
                    {
                        path: 'logs',
                        name: 'system-logs',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.system_logs').ucFirst();
                            },
                        },
                        component: () => import('@/views/helpers/grouper/grouper.vue'),
                        children: [
                            ...newsletterLogs
                        ]
                    },
                ]
            }
        ]
    },
    {
        path: '/auth',
        name: 'auth',
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: authRoutes
    }
];